module.exports = __webpack_public_path__ + "60d395670c581a34ead93a3b920d4537.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/app_icons/AQI.png
// module id = 1131
// module chunks = 0